import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getAppThemeName } from '../../services/appTheme';
const StyledCard = styled.div `
    position: relative;
    padding: 25px;
    border-radius: ${props => (props.appTheme === 'invoned' ? '5px' : '9px')};
    background-color: white;
    box-shadow: 0 0 10px rgba(26, 26, 26, 0.11);

    @media only screen and (min-width: 768px) {
        width: 475px;
        padding: 30px 45px;
    }
`;
const Card = ({ className, children }) => (_jsx(StyledCard, { className: className, appTheme: getAppThemeName(), children: children }));
export default Card;
